<div class="row paddingLeft2x">
  <div class="alignTooltips">
    <prism-ui-copy>
      <label>{{lifeStructureContent.label}}</label>
    </prism-ui-copy>
    <div class="toolTipLeftPadding">
      <prism-ui-icon-button
        expanded="false"
        has-tooltip="true"
        icon-name="circle-info"
        is-inactive="false"
        is-waiting="false"
        key-id="{{lifeStructureElement.tooltip}}"
        label="{{lifeStructureToolTipDescription}}"
        size="small"
        [tooltipPosition]="lifeStructureTooltipPosition"
        type="button"
        variant="tertiary"
        >
        <div class="lifeStructureTooltipWidth lifeStructureTooltipPadding">
          <prism-ui-copy key-id="lifeStructureTooltip">{{lifeStructureToolTipDescription}}</prism-ui-copy>
        </div>
      </prism-ui-icon-button>
    </div>
  </div>
</div>
<div class="row paddingLeft2x paddingBottom">
  <prism-ui-form-field-select
    key-id="scheduleRadio"
    form-field-items-count="2"
    [isValid]="formControlUtilitiesService.isControlValid(parentForm, product.key + '_schedule')"
    orientation="{{screenOrientation}}"
    hide-legend="true"
    >
    <span slot="error">Please select a coverage schedule</span>
  </prism-ui-form-field-select>
  <div class="containerLifeSchedule">
    <div class="item dollar">
      <prism-ui-radio-button
        slot="input-1"
        label-text="Dollar"
        [keyId]="product.key + bothSchedule[0].abbreviation.toUpperCase()"
        ngDefaultControl
        [name]="product.key + bothSchedule[0].abbreviation.toUpperCase()"
        formControlName="{{ product.key }}"
        [checked]="parentForm.get(product.key + '_schedule').value === bothSchedule[0].abbreviation.toUpperCase()"
        [isValid]="formControlUtilitiesService.isControlValid(parentForm, product.key + '_schedule')"
        (prismUiRadioButtonOnChange)="logLifeRadioChangeEvent(product.key, bothSchedule[0].abbreviation.toUpperCase())"
        >
      </prism-ui-radio-button>
    </div>
    <div class="item mult">
      <prism-ui-radio-button
        slot="input-2"
        label-text="Multiple of Salary"
        [keyId]="product.key + bothSchedule[1].abbreviation.toUpperCase()"
        ngDefaultControl
        [name]="product.key + bothSchedule[1].abbreviation.toUpperCase()"
        formControlName="{{ product.key }}"
        [checked]="parentForm.get(product.key + '_schedule').value === bothSchedule[1].abbreviation.toUpperCase()"
        [isValid]="formControlUtilitiesService.isControlValid(parentForm, product.key + '_schedule')"
        (prismUiRadioButtonOnChange)="logLifeRadioChangeEvent(product.key, bothSchedule[1].abbreviation.toUpperCase())"
        >
      </prism-ui-radio-button>
    </div>
  </div>

</div>
@if (parentForm.get(product.key + '_schedule').value === 'DOLLAR' ) {
  <app-life-schedule-dollar [product]="product" [parentForm]="parentForm"></app-life-schedule-dollar>
}
@if (parentForm.get(product.key + '_schedule').value === 'SALARY' ) {
  <app-life-schedule-salary [product]="product" [parentForm]="parentForm"></app-life-schedule-salary>
}